export enum ReportFilterType {
  DATE = 'DATE',
  ELEMENTS = 'ELEMENTS',
  SINGLE_ELEMENT = 'SINGLE_ELEMENT',
  NUMBER_OF_ELEMENTS = 'NUMBER_OF_ELEMENTS',
  NUMBER_OF_STACKED_ELEMENTS = 'NUMBER_OF_STACKED_ELEMENTS',
  SINGLE_STATISTIC = 'SINGLE_STATISTIC',
  MULTIPLE_STATISTICS = 'MULTIPLE_STATISTICS',
  OVER_TIME_GRAPH_TYPE = 'OVER_TIME_GRAPH_TYPE',
  CALLS_QUOTA_ELEMENTS = 'CALLS_QUOTA_ELEMENTS',
}
